import { createFileRoute } from '@tanstack/react-router'

import {
  CoursesManagementListView,
  coursesManagementFiltersSchema
} from '@/modules/coursesManagement'

export const Route = createFileRoute('/_auth/courses-management/')({
  component: CoursesManagementListView,
  validateSearch: coursesManagementFiltersSchema
})
